import React, { useEffect } from 'react'

import { FormControl, Grid, TextField } from '@mui/material'

import { SlipSection } from './SlipSection'

export const CashRefill = ({ useFetchInit, readOnlyMode }) => {

    const {
        Forms,
        // FetchData
    } = useFetchInit

    const { FormScreen } = Forms
    const { formState, onInputNumberChange } = FormScreen

    useEffect(() => {

        const str_monto_solicitado = parseFloat(formState.monto_solicitado)
            .toLocaleString('en-US', {
                minimumFractionDigits: 2, maximumFractionDigits: 2
            }) || ''

        onInputNumberChange({
            target: {
                name: 'monto_aprobado',
                value: str_monto_solicitado
            }
        })
    }, [formState.monto_solicitado])

    return (
        <>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="monto_solicitado"> * Monto a Solicitar</label>
                        <TextField
                            id='monto_solicitado'
                            name='monto_solicitado'
                            value={ formState.monto_solicitado_mask } 
                            onChange={ onInputNumberChange }
                            size='small'
                            placeholder='500.50, 100.00'
                            type='text'
                            variant={readOnlyMode? 'filled': 'outlined'}
                            hiddenLabel
                            InputProps={{
                                readOnly: readOnlyMode 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="monto_aprobado"> * Monto Aprobado</label>
                        <TextField
                            id='monto_aprobado'
                            name='monto_aprobado'
                            value={ formState.monto_aprobado_mask } 
                            onChange={ onInputNumberChange }
                            size='small'
                            placeholder='500.50, 100.00'
                            type='text'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            {(formState.idgestion > 0 && formState.idgestion !== '')&&(
                <SlipSection useFetchInit={useFetchInit} readOnlyMode={readOnlyMode}/>
            )}            
        </>
    )
}
